<template>
  <v-dialog
    v-model="dialogVisible"
    max-width="655"
    class="rounded-xl"
    persistent
  >
    <v-card width="100%" class="px-6 py-6">
      <v-form ref="declineForm" v-model="declineFormValid" @submit.prevent="declineDoc">
        <v-card-title>{{ $t('documentSignatureCustomization.modal.declineReason.title') }}</v-card-title>
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-text-field
                id="decline_reason"
                v-model="message"
                full-width
                :label="$t('dialog.confirmation.decline.label')"
                :counter="maxCharacters"
              ></v-text-field>
            </v-row>
          </v-container>
        </v-card-text>
      </v-form>
      <v-card-actions>
        <v-btn
          class="mr-2"
          @click="$emit('closed')"
        >
          <v-icon>
            mdi-close-circle-outline
          </v-icon>
          {{ $t('main.cancel') }}
        </v-btn>
        <v-btn
          id="decline_confirm_btn"
          :disabled="!declineFormValid"
          color="error"
          outlined
          @click="declineDoc"
        >
          <v-icon>
            mdi-delete-outline
          </v-icon>
          {{ $t('dialog.confirmation.decline.decline') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { showToastError, showToastSuccess } from '../../event-bus'
import signatures from '../../services/api/signatures'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    signatureId: {
      type: Number,
      default: -1
    },
    currentSignatureId: {
      type: String,
      default: ''
    }
  },
  emits: ['declined', 'closed'],
  data() {
    return {
      dialogVisible: this.visible,
      declineFormValid: true,
      message: '',
      maxCharacters: 255,
      rules: {
        minMax: (v) => (v && v <= this.maxCharacters) || this.$t('validation.form.mustBeLessThan', { max: this.maxCharacters })
      }
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
    },
    dialogVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    async   declineDoc() {
      const signRequest = {
        currentSignatureId: this.currentSignatureId || null,
        comment: this.message.length > 0 ? this.message : null
      }
      const signatureId = this.signatureId
      try {
        await signatures.decline(signatureId, signRequest)
        showToastSuccess(this.$t('toastMessage.succesfullyDeclined'))
        this.$emit('declined')
      } catch (error) {
        const errorMsg = this.getErrorMessage(error)
        showToastError(errorMsg)
      }
    }
  }

}
</script>

<style>
</style>
